import React, { useCallback, useEffect, useState } from "react";
import CourseItem from "../../components/CourseItem/CourseItem";

import courseImg from "../../assets/images/course_img.png";
import PopularCard from "../../components/PopularCard/PopularCard";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../components/table/Table";
import { courseList } from "./content";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { api } from "../../api/api";
import { ReactComponent as Trash } from "../../assets/images/delete_icon.svg";
import { ReactComponent as Edit } from "../../assets/images/edit.svg";
import { debounce } from "lodash";
import moment from "moment";
const Course = () => {
  const [data, setData] = useState(courseList);
  const { currUserData } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const courses = [
    {
      title: "React for Beginners",
      description:
        "Learn the fundamentals of React, including components, JSX, state, and props.",
      instructor: "Jane Doe",
      image: courseImg, // Replace with an actual image URL

      price: 49.99,
      url: "/courses/react-for-beginners",
    },
    {
      title: "Advanced JavaScript",
      description:
        "Dive deep into JavaScript, including closures, promises, async/await, and more.",
      instructor: "John Smith",
      image: courseImg, // Replace with an actual image URL
      price: 59.99,
      url: "/courses/advanced-javascript",
    },
  ];

  const handleEdit = (rowIndex) => {
    const newData = [...data];
    const updatedValue = prompt(
      "Enter new value:",
      newData[rowIndex].CenterName
    );
    if (updatedValue) {
      newData[rowIndex].CenterName = updatedValue;
      setData(newData);
    }
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getCourseData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const getCourseData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/course/getCourses?page=${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.data);
      setTotalCount(res?.totalCourses);

      setIsLoading(false);
    }
  };
  const handleDelete = async (rowIndex, _id) => {
    try {
      console.log("Deleting course with ID:", _id);

      let res = await api(
        `api/v1/course/deleteCourse/${_id}`,
        {},
        "delete",
        currUserData?.token,
        ""
      );

      if (res && res.success) {
        getCourseData();
      }
    } catch (error) {
      console.error("Error during delete request:", error);
    }
  };

  const handlePublish = async (id) => {
    console.log(id, "id");

    let res = await api(
      `api/v1/course/updateCourseLive/${id}`,
      {},
      "patch",
      currUserData.token,
      ""
    );
    if (res && res.success) {
      getCourseData();
      // setSubscriptionData(res?.data);
      console.log(res, "live");
    }
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "courseId",
      },
      {
        Header: "Name",
        accessor: "title",
      },

      {
        Header: "Module",
        accessor: "content",
        Cell: ({ row }) => (
          <p>{row.original.content ? row.original.content.length : 0}</p>
        ),
      },

      {
        Header: "Publish",
        accessor: "status",
        Cell: ({ row }) => (
          <p>{row.original.status === 1 ? "published" : "not published"}</p>
        ),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div class="dropdown">
            <span
              data-bs-toggle="dropdown"
              style={{ cursor: "pointer" }}
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </span>
            <ul class="dropdown-menu">
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate(`/course/${row.original._id}`);
                  }}
                >
                  View
                </span>
              </li>
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handlePublish(row.original._id);
                  }}
                >
                  Publish
                </span>
              </li>
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate(`/add-course?id=${row.original._id}`);
                  }}
                >
                  Edit
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(row.index, row.original._id)}
                >
                  Delete
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getCourseData();
  }, [pageIndex, pageSize]);
  return (
    <div className="p-40">
      {/* <div className="page_heading mb-4">
        <div className="d-flex justify-content-between align-items-center w-100">
          <p className="heading">Popular</p>
          <Link to={"#"} className="link">
            View More
          </Link>
        </div>
      </div> */}
      {/* <div className="row mb-5">
        <div className="col-md-3">
          <PopularCard />
        </div>
        <div className="col-md-3">
          <PopularCard />
        </div>
        <div className="col-md-3">
          <PopularCard />
        </div>
        <div className="col-md-3">
          <PopularCard />
        </div>
      </div> */}
      <div className="page_heading mb-4">
        <div>
          <p className="heading">My Course</p>
        </div>
        <button className="btn_primary" onClick={() => navigate("/add-course")}>
          +Add Course
        </button>
      </div>
      <div className="row">
        {/* {courses.map((course) => (
          <div className="col-md-4">
            <CourseItem key={course.title} course={course} />
          </div>
        ))} */}

        <Table
          columns={columns}
          data={data}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
          onSearch={handelSearch}
          isLoading={isLoading}
          totalCount={totalCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default Course;
